<template>
  <a-card title="出厂水质实时监测" :bordered="false" class="factory-water-card">
    <template slot="extra">
      <span class="update-time">更新时间：2025.11.17 10:54:00</span>
    </template>
    <div class="chart-container">
      <div ref="radarChartRef" style="width: 100%; height: 320px;"></div>
      <div class="chart-footer">数据来源：水质在线监测系统（每小时采样1次）</div>
    </div>
  </a-card>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'FactoryWaterQualityMonitoring',
  data () {
    return {
      chart: null
    }
  },
  mounted () {
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    handleResize () {
      this.chart && this.chart.resize()
    },
    initChart () {
      const chartDom = this.$refs.radarChartRef
      if (!this.chart) {
        this.chart = echarts.init(chartDom)
      }

      const option = {
        // title: {
        //   text: 'XX水厂出厂水水质监测',
        //   left: 'center',
        //   top: '5%',
        //   textStyle: {
        //     fontSize: 14,
        //     fontWeight: 'normal',
        //     color: '#333'
        //   }
        // },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          show: false
        },
        radar: {
          indicator: [
            { name: 'pH值', max: 1.2 },
            { name: '浊度\n(NTU)', max: 1.2 },
            { name: '余氯\n(mg/L)', max: 1.2 },
            { name: '耗氧量\n(mg/L)', max: 1.2 },
            { name: '氨氮\n(mg/L)', max: 1.2 },
            { name: '总硬度\n(mg/L)', max: 1.2 },
            { name: '细菌次数\n(CFU/mL)', max: 300 }
          ],
          center: ['50%', '55%'],
          radius: '65%',
          axisName: {
            color: '#666',
            fontSize: 11
          },
          splitArea: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#eee'
            }
          },
          axisName: {
            color: '#666',
            fontSize: 11
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: ['#fff', '#fcfcfc']
            }
          },
          axisLine: {
            lineStyle: {
              color: '#eee'
            }
          }
        },
        series: [
          {
            type: 'radar',
            data: [
              {
                value: [0.95, 0.85, 0.9, 0.95, 0.8, 0.95, 250],
                name: '参考阈值',
                symbol: 'circle',
                symbolSize: 4,
                label: {
                  show: true,
                  fontSize: 10,
                  color: '#3366ff',
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  borderRadius: 2,
                  padding: [2, 4]
                },
                lineStyle: {
                  type: 'dashed',
                  color: '#3366ff',
                  width: 2
                },
                areaStyle: {
                  color: 'rgba(51, 102, 255, 0.1)'
                }
              },
              {
                value: [0.7, 0.5, 0.6, 0.8, 0.5, 0.7, 200],
                name: '实际监测值',
                symbol: 'circle',
                symbolSize: 4,
                label: {
                  show: true,
                  fontSize: 10,
                  color: '#ff4d4f',
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  borderRadius: 2,
                  padding: [2, 4]
                },
                itemStyle: {
                  color: '#ff4d4f'
                },
                lineStyle: {
                  color: '#ff4d4f',
                  width: 2
                },
                areaStyle: {
                  color: 'rgba(255, 77, 79, 0.4)'
                }
              }
            ]
          }
        ]
      }

      this.chart.setOption(option)
    }
  }
}
</script>

<style lang="less" scoped>
.factory-water-card {
  .update-time {
    color: #999;
    font-size: 13px;
  }

  .chart-container {
    position: relative;

    .chart-footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: center;
      font-size: 11px;
      color: #999;
    }
  }
}
</style>
